import { useCallback, useEffect, useState } from 'react'

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>
}

let deferredPrompt: BeforeInstallPromptEvent | null = null

window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault()
  deferredPrompt = event as BeforeInstallPromptEvent
  window.dispatchEvent(new Event('mediathekview-install-available'))
})

window.addEventListener('appinstalled', () => {
  deferredPrompt = null
  window.dispatchEvent(new Event('mediathekview-app-installed'))
})

export function registerPwa() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => undefined), { once: true })
  }
}

export function usePwaInstall() {
  const standalone = window.matchMedia('(display-mode: standalone)').matches
  const [available, setAvailable] = useState(Boolean(deferredPrompt) && !standalone)

  useEffect(() => {
    const update = () => setAvailable(Boolean(deferredPrompt) && !window.matchMedia('(display-mode: standalone)').matches)
    window.addEventListener('mediathekview-install-available', update)
    window.addEventListener('mediathekview-app-installed', update)
    return () => {
      window.removeEventListener('mediathekview-install-available', update)
      window.removeEventListener('mediathekview-app-installed', update)
    }
  }, [])

  const install = useCallback(async () => {
    const prompt = deferredPrompt
    if (!prompt) return
    await prompt.prompt()
    await prompt.userChoice
    deferredPrompt = null
    setAvailable(false)
  }, [])

  return { available, install }
}
